module.exports = __webpack_public_path__ + "static/shootball-5fda09d609e34acab835bb261f712f4d.png";